/**
 * D5 — escolher a categoria de UM grupo (tela do grupo). Sem permissão de editar, mostra só
 * a etiqueta (ou nada).
 */
import { NativeSelect, useToast } from '@mgdlead/ui';

import { useGroupCategories, useSetGroupCategory } from '../../../lib/api';
import { humanizeError } from '../../../lib/errors';

const SEM = '';

export interface GroupCategorySelectProps {
  workspaceId: string;
  groupId: string;
  categoryId: string | null;
}

export function GroupCategorySelect({
  workspaceId,
  groupId,
  categoryId,
}: GroupCategorySelectProps) {
  const { toast } = useToast();
  const categorias = useGroupCategories(workspaceId);
  const set = useSetGroupCategory();

  const options = [
    { value: SEM, label: 'Sem categoria' },
    ...(categorias.data ?? []).map((c) => ({ value: c.id, label: c.name })),
  ];

  return (
    <NativeSelect
      size="sm"
      aria-label="Categoria do grupo"
      value={categoryId ?? SEM}
      options={options}
      disabled={categorias.isPending || set.isPending}
      onChange={(event) =>
        set.mutate(
          {
            workspaceId,
            groupId,
            categoryId: event.target.value === SEM ? null : event.target.value,
          },
          {
            onError: (e: unknown) =>
              toast({
                title: 'Não deu para mudar a categoria',
                description: humanizeError(e),
                tone: 'danger',
              }),
          },
        )
      }
    />
  );
}
